import { Callout } from "@octopusdeploy/design-system-components";
import type { ResourceCollection, EventResource, EventCategoryResource, Repository } from "@octopusdeploy/octopus-server-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import { repository } from "~/clientInstance";
import EventListing from "~/components/EventListing/EventListing";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import { PageContent } from "~/components/PageContent/PageContent";
import PermissionCheck from "~/components/PermissionCheck/PermissionCheck";
interface MyRecentActivityLoaderData {
    events: ResourceCollection<EventResource>;
    eventCategories: EventCategoryResource[];
    userId: string;
}
interface MyRecentActivityProps {
    loaderData: MyRecentActivityLoaderData;
}
export const myRecentActivityPageTitle = "My Recent Activity";
export async function myRecentActivityPageLoader(repository: Repository, userId: string): Promise<MyRecentActivityLoaderData> {
    const useOptimization = isFeatureToggleEnabled("PermissionCheckOptimizationFeatureToggle");
    const eventsPromise = useOptimization ? repository.Events.getUnpaginatedEvents({ users: [userId], includeSystem: "false" }) : repository.Events.list({ users: [userId], includeSystem: "false" });
    const eventCategoriesPromise = repository.Events.categories({});
    return {
        events: await eventsPromise,
        eventCategories: await eventCategoriesPromise,
        userId,
    };
}
export const MyRecentActivityPage: React.FC<MyRecentActivityProps> = ({ loaderData }) => {
    return (<PageContent header={{ title: myRecentActivityPageTitle }}>
            <PermissionCheck permission={Permission.EventView} wildcard={true} alternate={<Callout type={"information"} title={"Permission required"}>
                        The {Permission.EventView} permission is required to view recent activity
                    </Callout>}>
                {loaderData.events && (<EventListing data={loaderData.events} eventCategories={loaderData.eventCategories} onPageSelected={async (skip: number, p: number) => {
                const result = await repository.Events.list({ users: [loaderData.userId], includeSystem: "false", skip });
                return result;
            }} noDataMessage={"There's no activity to show"}/>)}
            </PermissionCheck>
        </PageContent>);
};
MyRecentActivityPage.displayName = "MyRecentActivityPage"
